
import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../types';

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  return (
    <Link to={`/product/${product.id}`} className="product-card group flex flex-col gap-4">
<div className="relative w-full aspect-[4/5] rounded-xl overflow-hidden bg-white border border-gray-200">
  {product.isNew && (
    <div className="absolute top-3 left-3 z-10 bg-black text-white text-[10px] font-bold px-2 py-1 rounded uppercase tracking-widest italic">
      Nuevo
    </div>
  )}

  <img
    src={product.image}
    alt={product.name}
    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
  />

  <button className="absolute bottom-4 left-4 right-4 h-12 bg-white text-black font-bold uppercase tracking-wide text-sm rounded flex items-center justify-center gap-2 opacity-0 transform translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 shadow-xl hover:bg-gray-100 border border-gray-100 italic">
    <span className="material-symbols-outlined text-[18px]">visibility</span>
    Ver Detalles
  </button>
</div>


      <div>
        <div className="flex justify-between items-start mb-1">
          <p className="text-black text-lg font-bold leading-tight uppercase italic">{product.name}</p>
          <p className="text-black font-bold italic">{product.price.toFixed(2)}€</p>
        </div>
        <p className="text-gray-500 text-sm font-medium">{product.description}</p>
      </div>
    </Link>
  );
};

export default ProductCard;
